// Reducer for the WhatsApp recipients picker cluster: the selected recipients and
// the picker's search query. They belong to the same widget and change together
// as the user picks/searches, so they share one reducer.

export const initialRecipientsState = {
    recipients: [], // [{type:'phone'|'group', value, label}]
    search: '',
};

export function recipientsReducer(state, action) {
    switch (action.type) {
        case 'SET_RECIPIENTS':
            return { ...state, recipients: action.value };
        case 'SET_SEARCH':
            return { ...state, search: action.value };
        default:
            return state;
    }
}
